export default class DevBox {
  constructor (Vue, options = {}) {
    this.store = new Vue({
      data () {
        return {
          components: options.components || {},
          isOpen: options.isOpen || false
        }
      }
    })
  }

  get state () {
    return this.store.$data
  }

  open () {
    this.store.$data.isOpen = true
  }

  close () {
    this.store.$data.isOpen = false
  }

  addComponent (component) {
    this.store.$data.components[component.name] = component
  }

  removeComponent (component) {
    delete this.store.$data.components[component.name]
  }

  static install (Vue, options = {}) {
    const devBox = new DevBox(Vue, options)

    Vue.prototype.$devBox = devBox

    Vue.mixin({
      created () {
        if (!this.$options.devBoxComponents) return

        this.$options.devBoxComponents.forEach(devBox.addComponent.bind(devBox))
        this.$devBox.close()
      },
      destroyed () {
        if (!this.$options.devBoxComponents) return

        this.$options.devBoxComponents.forEach(devBox.removeComponent.bind(devBox))
        this.$devBox.close()
      }
    })
  }
}
